<span>

<span style="background-color: #000000;">  </span><span style="color: #000000;">&nbsp;NOIR HD</span><br>
<span style="background-color: #765ba7;">  </span><span style="color: #765ba7;">&nbsp;VIOLET</span><br>
<span style="background-color: #3255a4;">  </span><span style="color: #3255a4;">&nbsp;BLEU FRANC</span><br>
<span style="background-color: #0078bf;">  </span><span style="color: #0078bf;">&nbsp;BLEU</span><br>
<span style="background-color: #5ec8e5;">  </span><span style="color: #5ec8e5;">&nbsp;AQUA</span><br>
<span style="background-color: #00838a;">  </span><span style="color: #00838a;">&nbsp;VERT CANARD</span><br>
<span style="background-color: #00a95c;">  </span><span style="color: #00a95c;">&nbsp;VERT</span><br>
<span style="background-color: #44d62c;">  </span><span style="color: #44d62c;">&nbsp;VERT FLUO</span><br>
<span style="background-color: #ffe800;">  </span><span style="color: #ffe800;">&nbsp;JAUNE</span><br>
<span style="background-color: #ff6c2f;">  </span><span style="color: #ff6c2f;">&nbsp;ORANGE</span><br>
<span style="background-color: #ffa240;">  </span><span style="color: #ffa240;">&nbsp;ORANGE FLUO</span><br>
<span style="background-color: #ff48b0;">  </span><span style="color: #ff48b0;">&nbsp;ROSE FLUO</span><br>
<span style="background-color: #ed0000;">  </span><span style="color: #ed0000;">&nbsp;ROUGE BRILLANT</span><br>
<span style="background-color: #914e72;">  </span><span style="color: #914e72;">&nbsp;ROUGE BORDEAUX</span><br>
<span style="background-color: #ac936e;">  </span><span style="color: #ac936e;">&nbsp;DORÉ MÉTALLISÉ</span>

</span>
